var render, staticRenderFns
import script from "./DevelopmentTags.vue?vue&type=script&lang=js"
export * from "./DevelopmentTags.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentTags.vue?vue&type=style&index=0&id=989ece4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports